module.exports = "//img4.xes1v1.com/resources/fe-1v1-pclp/img/header.74e8a6ec.png";